import { render, staticRenderFns } from "./CompetitorElement.vue?vue&type=template&id=1bcd6b78&scoped=true"
import script from "./CompetitorElement.vue?vue&type=script&lang=js"
export * from "./CompetitorElement.vue?vue&type=script&lang=js"
import style0 from "./CompetitorElement.vue?vue&type=style&index=0&id=1bcd6b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd6b78",
  null
  
)

export default component.exports